export const actionInputName = (actionBaseName, actionName, isProposed) =>
  `${isProposed ? "proposedAction" : actionBaseName}.${actionName}`;

export const actionFormValue = (
  values,
  actionBaseName,
  actionName,
  isProposed
) => values?.[isProposed ? "proposedAction" : actionBaseName]?.[actionName];
